// extracted by mini-css-extract-plugin
module.exports = {"emailVerificationWrapper":"_f001898","buttonsWrapper":"_26f51cc"};